export default __webpack_public_path__ + "static/media/in-progress.998e8094.png";